import { ActionTree } from 'vuex'

import { fetchPostcodeData } from '@/sdk/clients/PostcodeClient'
import { RootState } from '@/store/types'

import { MapData, Mutations, PostcodeState } from './types'

const actions: ActionTree<PostcodeState, RootState> = {
  setMapData({ commit }, value: MapData) {
    commit(Mutations.SET_MAP_DATA, value)
  },

  setPostcode({ commit }, value: string) {
    commit(Mutations.SET_POSTCODE, value)
  },

  async fetchPostcodeData({ commit, state }, postcode: string) {
    if (state.postcodes[postcode]) {
      return
    }

    const postcodeData = await fetchPostcodeData(postcode)

    commit(Mutations.SET_POSTCODES_DATA, postcodeData)
  },
}

export default actions
